import { LUT } from '@react-three/postprocessing';
import { useAsset } from '@artica/assets';

export default function Lut() {  
  return (
    <LUT
      lut={ useAsset('arctic_freeze') }
      tetrahedralInterpolation={ true }
    />
  );
};